import { UserGame } from '../public-api';

export class Statistics {
  games: Array<UserGame>;
  playedGames: number;
  wonGames: number;
  lostGames: number;
}
